import { render, staticRenderFns } from "./crewProblem.vue?vue&type=template&id=6298bb24&scoped=true"
import script from "./crewProblem.vue?vue&type=script&lang=js"
export * from "./crewProblem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6298bb24",
  null
  
)

export default component.exports